import { render, staticRenderFns } from "./DetalleProgramaciones.vue?vue&type=template&id=5c7f862a&"
import script from "./DetalleProgramaciones.vue?vue&type=script&lang=js&"
export * from "./DetalleProgramaciones.vue?vue&type=script&lang=js&"
import style0 from "./DetalleProgramaciones.vue?vue&type=style&index=0&id=5c7f862a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports